'use client';

import React, { MouseEventHandler } from 'react';
import Link from 'next/link';

interface Props {
  icon?: any;
  label: string;
  href: string;
  openNewWindow: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  children?: React.ReactNode;
}

const Button = ({
  icon,
  label = 'Read more',
  href = '#',
  openNewWindow,
  onClick,
  children,
}: Props) => {
  return (
    href && (
      <Link
        href={href}
        target={openNewWindow ? '_blank' : '_self'}
        rel={openNewWindow ? 'noopener noreferrer' : ''}
        className="m-0 mb-5 inline-flex w-auto cursor-pointer flex-wrap justify-around rounded-sm border border-solid border-[transparent] bg-clayton-blue px-[30px] py-[17px] text-center font-source-sans text-[14px] font-semibold uppercase tracking-[1px] text-white no-underline"
        onClick={onClick}
      >
        {icon ? (
          <div className="icon">
            ({icon}
            {label} || {children})
          </div>
        ) : (
          <div className="font-source-sans text-[14px] font-bold tracking-[0.5px] text-white no-underline">
            {label}
          </div>
        )}
      </Link>
    )
  );
};

export default Button;
